import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-capacitacion-tutor-moodle',
  templateUrl: './capacitacion-tutor-moodle.component.html',
  styleUrls: ['./capacitacion-tutor-moodle.component.css']
})
export class CapacitacionTutorMoodleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
